import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PinterestIcon from '@mui/icons-material/Pinterest';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export type SimpleSocialMedia = {
  name: string;
  userName: string;
};

export type SocialMedia = {
  name: string;
  label: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  userPrefix?: string;
  url: string;
};

export type SocialMediaWithUrl = {
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  url: string;
};

export type SocialMediaConfig = {
  [key: string]: SocialMedia;
};

const arrayToConfig = (medias: SocialMedia[]) => {
  const config: SocialMediaConfig = {};
  medias.forEach((media) => {
    config[media.name] = media;
  });
  return config;
};

export const facebookConfig: SocialMedia = {
  name: 'FACEBOOK',
  label: 'facebook',
  icon: FacebookIcon,
  url: 'https://www.facebook.com',
};

export const instagramConfig: SocialMedia = {
  name: 'INSTAGRAM',
  label: 'instagram',
  icon: InstagramIcon,
  url: 'https://www.instagram.com',
};

export const linkedinConfig: SocialMedia = {
  name: 'LINKEDIN',
  label: 'linkedin',
  icon: LinkedInIcon,
  url: 'https://www.linkedin.com',
  userPrefix: 'in/',
};

export const pinterestConfig: SocialMedia = {
  name: 'PINTEREST',
  label: 'linkedin',
  icon: PinterestIcon,
  url: 'https://br.pinterest.com',
};

export const twitterConfig: SocialMedia = {
  name: 'TWITTER',
  label: 'twitter',
  icon: TwitterIcon,
  url: 'https://twitter.com/',
};

export const youtubeConfig: SocialMedia = {
  name: 'YOUTUBE',
  label: 'youtube',
  icon: YouTubeIcon,
  url: 'https://www.youtube.com/',
  userPrefix: 'channel/',
};

const socialMedias: SocialMedia[] = [
  facebookConfig,
  instagramConfig,
  linkedinConfig,
  pinterestConfig,
  twitterConfig,
  youtubeConfig,
];

export const socialMediasConfig = arrayToConfig(socialMedias);

export const buildMediaUserUrl = (socialMeda: SocialMedia, username: string) => {
  const urlParts: (string | undefined)[] = [];
  urlParts.push(socialMeda.url);

  if (socialMeda.url[socialMeda.url.length - 1] !== '/') {
    urlParts.push('/');
  }

  urlParts.push(socialMeda.userPrefix);
  urlParts.push(username);

  return urlParts.filter((part) => !!part).join('');
};

export const buildValidSocialMedia = (name: string, userName: string) => {
  if (!userName || userName.trim().length === 0) {
    return null;
  }

  if (socialMedias.map((sm) => sm.name).includes(name.toUpperCase())) {
    return { name, userName };
  }
  return null;
};

export const appendSocialMedia = (name: string, userName: string, medias: SimpleSocialMedia[]) => {
  const newSocialMedia = buildValidSocialMedia(name, userName);

  if (newSocialMedia) {
    medias.push(newSocialMedia);
  }
  return medias;
};

export default socialMedias;
